export { default } from './BlogEcommerceLink';